import { URL } from '../../../../config'
import { getRequest } from '../../../../utils/functions/httpRequest'

export const getUpcomingEvents = function (directorSSOEmail,token='') 
{
  const eventEndpoint = `/upcoming/${directorSSOEmail}`
  const eventURL =  `${URL.event}${eventEndpoint}` 
  return getRequest(eventURL,'json',token)
}



// WEBPACK FOOTER //
// ./src/containers/event/upcomingevent/api/getUpcomingEvents.js